export const services = [
  "Transportation",
  "Water Resources, Water Supply & Sewerage",
  "Urban, Regional & Industrial Development",
  "Environmental & Social Management",
  "Energy & Power",
  "Social & Economic Development",
];

export const staticCategories: string[] = [
  "All News",
  "Business",
  "Article",
  "Event & Media",
  "Others",
];

export const ALL_PROJECTS_STATUS = "All Status";
